var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconStakingUnactive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 23,
    viewBox: "0 0 13 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1005 2.31366L13 0.710266V22.4547H11.1005V2.31366Z",
    fill: "#968E53"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83971 6.89148L7.73926 5.28809V22.4548H5.83971V6.89148Z",
    fill: "#968E53"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M-1.37091e-05 11.4692L1.89954 9.86578V22.4547H-1.37091e-05V11.4692Z",
    fill: "#968E53"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStakingUnactive);
export default __webpack_public_path__ + "static/media/icon-staking-unactive.3f106ec9.svg";
export { ForwardRef as ReactComponent };